import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import Button from '../../../common/Button';
import { ConfirmLawyerLetterModalStyled } from "./ConfirmLawyerLetterModal.styled";

const ResultLawyerLetterModal = ({ show, onModalHide }) => {
    const { t } = useTranslation();
    const ltr = useSelector(state => state.common.ltrEnabled);

    return (
        <ConfirmLawyerLetterModalStyled
            show={show}
            onHide={onModalHide}
            centered
            size='lg'
            ltr={ltr}
        >
            <span
                className={'modal-close'}
                onClick={onModalHide}
            >
                &#215;
            </span>
            <div className='set-expense-title'>
                {t('buildings.nav_bar_lawyer_letter_success_title')}
            </div>

            <Modal.Body>
                <div style={{textAlign: 'center'}}>{t('buildings.nav_bar_lawyer_letter_success_subtitle')}</div>
                {/* <div style={{display: 'flex', justifyContent: 'center', marginTop: '32px'}}>
                  <Button
                      type='button'
                      onClick={onModalHide}
                      rounded={false}
                      outlined
                  >
                      {'ok'}
                  </Button>
                </div> */}
            </Modal.Body>
        </ConfirmLawyerLetterModalStyled>
    )
}

export default ResultLawyerLetterModal;
